import {ROLES} from '../../../../packages/domain/src/contract';
import type {PlayerNames,Role} from './model';
/** Custom player names are a per-device presentation preference; roles stay the source of truth. */
export const NAME_MAX_LENGTH=16;
/** Untrusted storage or patch value → only known roles with trimmed, non-empty, bounded names. */
export function playerNamesFrom(value:unknown):PlayerNames{
 if(!value||typeof value!=='object'||Array.isArray(value))return {};
 const names:PlayerNames={};
 for(const role of ROLES){const raw=(value as Record<string,unknown>)[role];if(typeof raw!=='string')continue;const name=raw.trim().slice(0,NAME_MAX_LENGTH).trim();if(name)names[role]=name;}
 return names;
}
/** The custom name when set, otherwise the role wording the caller would have shown. */
export const nameFor=(names:PlayerNames,role:Role,fallback:string)=>names[role]??fallback;
